import React from 'react';

export const ChevronPrimary = () => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.465421 0.405926C0.758327 0.113045 1.2332 0.113067 1.52608 0.405973L5.1227 4.00291L8.71967 0.405949C9.01256 0.113056 9.48744 0.113056 9.78033 0.405949C10.0732 0.698843 10.0732 1.17372 9.78033 1.46661L5.65301 5.59393C5.51235 5.73458 5.32158 5.8136 5.12266 5.8136C4.92375 5.81359 4.73298 5.73457 4.59233 5.5939L0.465374 1.46659C0.172494 1.17368 0.172515 0.698806 0.465421 0.405926Z"
        fill="#1F202F"
      />
    </svg>
  );
};
